<template>
  <div v-if="$auth0.isAuthenticated">
    <v-app-bar elevation="0" app dense color="whitegrey" class="pr-0">
      <v-app-bar-nav-icon v-if="true" @click.stop="clickNavIcon" color="black"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>

      <!-- <v-text-field rounded hide-details dense solo single-line flat class="elevation-0" color="white" append-icon="mdi-magnify" label="Pesquisar projetos" ></v-text-field> -->
      <!-- trocar por auto-complete  -->
      <v-autocomplete
        rounded hide-details dense solo single-line flat class="elevation-0"
        color="white" append-icon="mdi-magnify" :label="$t('projects.search.label')" 
        v-model="model"
        :items="items"
        :loading="isLoading"
        :search-input.sync="search"
        hide-no-data
        hide-selected
        item-text="name"
        item-value="id"
        :placeholder="$t('projects.search.placeholder')"
        :filter="customFilter"
        cache-items
        clearable
        :menu-props="{
          rounded: 'xl',
        }"
      >
        <template v-slot:item="data">
          <template class="black">
            <v-list-item-avatar v-if="false">
              <img :src="data.item.avatar">
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                <span class="caption">#{{ data.item.id }}</span>
                Projeto:
                <b>
                  {{ data.item.name }}
                </b> 
              </v-list-item-title>
              <v-list-item-subtitle>
                Cliente:
                <b>
                  {{ data.item.client_name }}
                </b> 
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </template>
      </v-autocomplete>

      <v-spacer></v-spacer>
      <div v-if="!is_mobile && $route.name != 'TicketScan'" class="d-flex align-center">
        <span> {{profile.name.split(' ')[0]}}</span>
        <v-icon class="ml-1 pr-1" color="black">mdi-account-circle</v-icon>
        <!-- <span class="text-h6 text--secondary">Perfil</span> -->
      </div>
    </v-app-bar>
  </div>
</template>
<script>
import { header_flow } from "@/router/links";
import resize from "@/mixins/resize";
import { mapMutations, mapState } from "vuex";
import AzoLogo from '../../assets/logos/azo-logo.png';
import Api from '@/api'

export default {
  components: {
    SideBar: () => import("./_drawer_01")
  },
  mixins: [resize],
  data() {
    return {
      logo: AzoLogo,
      links: header_flow,
      show_side_bar: false,

      isLoading: false,
      model: null,
      search: null,

      items: [],
    };
  },
  mounted () {
    this.setLinks()
  },
  methods: {
    customFilter (item, queryText, itemText) {
        const textOne = item.name.toLowerCase()
        const textTwo = item.client_name.toLowerCase()
        const searchText = queryText.toLowerCase()

        return textOne.indexOf(searchText) > -1 ||
          textTwo.indexOf(searchText) > -1
      },

    setLinks(){
      let links = [] //[...this.links]
      if(this.profile?.employee?.role){
        const ROLE = this.profile.employee.role
  
        this.links.forEach(el => {
          if (el.roles && el.roles.length){
            if ( el.roles.includes(ROLE) ) {
              if ( el.children && el.children.length ){
                let c = el.children.filter(child => child.roles.includes(ROLE))
                links.push({...el, children: c})
              } else{
                links.push(el)
              }
            }
          } else {
            links.push(el)
          }
        });
        
        this.links = [...links]
      }
    },
    clickNavIcon() {
      this.setDrawer(!this.$store.state.App.drawer);
    },
    ...mapMutations({
      setDrawer: "App/setDrawer"
    }),
  },
  computed: {
    ...mapState({
      profile: state=>state.User.oneUser,
      order_counter: state => state.Order.order_counter
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    profile(nv,ov) {
      if (nv){
        this.setLinks()
      } else if (nv == false){
  
      }
    },
    model(nv,ov) {
      if (nv){
        if (this.$route.name == 'OneProject'){
          this.$router.push({name: 'OneProject', params: {id: nv}})
          setTimeout(() => {
            this.$router.go()
          }, 300);
        } else {
          this.$router.push({name: 'OneProject', params: {id: nv}})
        }
      } else if (nv == false){
    
      }
    },
    search (val) {

      if (val && val.length >=3){
        // Items have already been requested
        if (this.isLoading) return
  
        this.isLoading = true
  
        let filter = {
          searches: {
            "name_or_client_name_i_cont_any": val,
            // "client_name_i_cont_any": val,
          }
        }
  
        // Lazily load input items
        Api.Project.index(filter).then(res => res.data).then(d => {
          const { count, entries } = d
          // this.count = count
          this.items = d
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
      }
    },

  },
};
</script>

<style scoped>

/* .logo{
  width: 120px !important;
  height: auto;
  margin-top: 10px;
} */

</style>